import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchDialogComponent } from './search-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { CbDialogModule } from '../dialog/dialog.module';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CbFormsModule } from '../forms/forms.module';
import { CbWaitForModule } from '@app/shared/directives/wait-for/wait-for.module';
import { CbHubTableModule } from '../table/table.module';
import { CbTableModule , CbDasherModule, CbLoadingSpinnerModule } from 'cb-hub-lib';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';




@NgModule({
    declarations: [
        SearchDialogComponent
    ],
    exports: [
        SearchDialogComponent
    ],
    imports: [
        CbFormsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        InfiniteScrollDirective,
        MatTableModule,
        MatIconModule,
        CbDasherModule,
        CbLoadingSpinnerModule,
        CbDialogModule,
        CommonModule,
        FormsModule,
        MatInputModule,
        MatListModule,
        CbWaitForModule,
        MatSelectModule,
        MatDatepickerModule,
        MatIconModule,
        MatCheckboxModule,
        MatTableModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        CbHubTableModule,
        CbTableModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
    ]
})
export class CbSearchDialogModule { }

